import { useCallback } from 'react';
import { useRouter } from '~/utils/navigation';
import { useSelector } from 'react-redux';
import useContextualPathTransformer from '~/hooks/use-contextual-path-transformer.js';
import {
	ROUTE_REGISTER,
	ROUTE_PLAY_NOW_BANKID,
	ROUTE_PLAY_NOW_DGA,
	ROUTE_GUEST_DEPOSIT_LOGIN
} from '~/components/router/constants.js';
import useConfiguration from '~/configuration/use-configuration.js';
import {
	selectOneBankIDFlowEnabled,
	selectOneButtonFlowEnabled
} from '~/store/feature-toggles/onboarding-feature-toggles';
/**
 * Initialize registration
 *
 * @example
 * import { useRegistration } from `@comeon/authentication`;
...
 * ...
 * const { redirectToRegister } = useRegistration();
 * redirectToRegister({from});
 * from is an optional parameter that can be passed if user needs to be redirected
 * to a url after login success
 * ...
 *
 */
const useRegistration = () => {
	const router = useRouter();
	const oneBankIDFlowEnabled = useSelector(selectOneBankIDFlowEnabled);
	const oneButtonFlowEnabled = useSelector(selectOneButtonFlowEnabled);
	const configuration = useConfiguration();
	const transformPath = useContextualPathTransformer();
	const { isAnonymous } = configuration;

	const redirectToRegister = useCallback(
		({ from } = {}) => {
			const params = from ? { from } : {};
			let REGISTER_PATH = '';
			if (oneBankIDFlowEnabled) {
				REGISTER_PATH = ROUTE_PLAY_NOW_BANKID;
			} else if (oneButtonFlowEnabled) {
				REGISTER_PATH = ROUTE_PLAY_NOW_DGA;
			} else if (isAnonymous) {
				REGISTER_PATH = ROUTE_GUEST_DEPOSIT_LOGIN;
			} else {
				REGISTER_PATH = ROUTE_REGISTER;
			}
			const state = { ...params };
			// TODO (navigation) - use search params or redux for state
			router.push(transformPath(REGISTER_PATH), {
				state
			});
		},
		[oneBankIDFlowEnabled, oneButtonFlowEnabled, isAnonymous, router, transformPath]
	);

	return { redirectToRegister };
};

export default useRegistration;
